import { Component, ChangeDetectorRef } from '@angular/core';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { MenuService } from './shared/services/menu.service';
import * as debug from './shared/services/debug.service';
import { isMobileWindow } from './shared/utils/utility.common';
import { appUrl } from 'src/environments/environment';
import { SecurityService } from './shared/services/security.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent {
	settings: Settings;
	isHorizontalMenu = true;

	constructor(
		public readonly appSettings: AppSettings,
		public readonly menuService: MenuService,
		public readonly securityService: SecurityService,
		private cdr: ChangeDetectorRef
	) {
		securityService.getUserProfile(
			appUrl.guestProfile,
			`039.0 AppComponent instantiated`
		);

		this.settings = this.appSettings.settings;
		this.menuService.sidenavIsOpenedChanged.subscribe((isOpen) => {
			this.isHorizontalMenu = !isOpen;

			if (isMobileWindow()) {
				this.settings.menu = AppSettings.MenuOrientation.HORIZONTAL;
			} else {
				this.settings.menu = isOpen
					? AppSettings.MenuOrientation.VERTICAL
					: AppSettings.MenuOrientation.HORIZONTAL;
			}

			this.cdr.detectChanges();
			// if (isOpen) {
			//     this.settings.sidenavIsPinned = true;
			// }
			debug.log(
				`039 AppComponent sidenavIsOpenedChanged.subscribe isHorizontalMenu: ${this.isHorizontalMenu} this.settings.menu: ${this.settings.menu} this.settings.sidenavIsPinned: ${this.settings.sidenavIsPinned}`
			);
		});

		// this.menuService.isBusyChanged.subscribe(isBusy => {
		//     this.cdr.detectChanges();
		//     debug.log(`===========AppComponent isBusyChanged.subscribe isBusy: ${this.menuService.isBusy}`);
		// });
	}
}
